import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import getScrollDirection from '~/js/helpers/get-scroll-direction';
import Dropdown from '~/js/modules/dropdown'
import '../site-search/site-search.js';

const DROPDOWN_IDS = [
  `location`
]
let pageOffsetTop = 0;

document.addEventListener(`DOMContentLoaded`, () => {
  const header = document.querySelector(`.header`)

  if (header) {
    const headerMenuToggleBtn = header.querySelector(`.js-header-menu-toggle`)
    if (headerMenuToggleBtn) {
      headerMenuToggleBtn.addEventListener(`click`, () => {
        if (!header.classList.contains(`opened`)) {
          header.classList.remove(`scrolled`);
          pageOffsetTop = pageYOffset;
          disableBodyScroll(header);
        } else {
          header.scroll(0, 0);
          window.scroll(0, pageOffsetTop);
          clearAllBodyScrollLocks();
        }

        header.classList.toggle(`opened`)
      })
    }

    if (window.innerWidth >= 1024) {
      header.classList.remove(`opened`);
      header.classList.remove(`scrolled`);
    }
    
    let lastScrollTop = 0;

    const scrollHandler = () => {
      if (window.pageYOffset > header.offsetTop) {
        header.classList.add("is-active");
      } else {
        header.classList.remove("is-active");
      }
      
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop){
        header.classList.add("is-down");
      } else {
        header.classList.remove("is-down");
      }
      lastScrollTop = st <= 0 ? 0 : st; 
    };
     
    window.addEventListener("scroll", () => {
      scrollHandler()
    });
  }

  if (DROPDOWN_IDS.length) {
    DROPDOWN_IDS.forEach(id => new Dropdown(id))
  }

  window.addEventListener(`resize`, () => {
    if (window.innerWidth >= 1024) {
      clearAllBodyScrollLocks();
      header.classList.remove(`opened`);
      header.classList.remove(`scrolled`);
    }
  });

  window.addEventListener(`scroll`, () => {
    if (window.innerWidth < 1024) {
      if (header.classList.contains(`opened`)) {
        return;
      }

      const down = getScrollDirection() === 1;
      const up = getScrollDirection() === -1;

      if (down) {
        if (window.innerWidth < 1024) {
          if (pageYOffset > header.offsetHeight) {
            header.classList.add(`scrolled`);
          }
        } else {
          if (pageYOffset > 0) {
            header.classList.add(`scrolled`);
          }
        }
      }

      if (up) {
        if (pageYOffset + window.innerHeight < document.body.scrollHeight) {
          header.classList.remove(`scrolled`);
        }
      }
    }
  });
})
